var map = {
	"./en-au.json": [
		"./src/assets/i18n/en-au.json",
		0
	],
	"./en-ca.json": [
		"./src/assets/i18n/en-ca.json",
		1
	],
	"./en-gb.json": [
		"./src/assets/i18n/en-gb.json",
		2
	],
	"./en-nz.json": [
		"./src/assets/i18n/en-nz.json",
		3
	],
	"./en-us.json": [
		"./src/assets/i18n/en-us.json",
		4
	],
	"./en.json": [
		"./src/assets/i18n/en.json",
		5
	],
	"./es-gt.json": [
		"./src/assets/i18n/es-gt.json",
		6
	],
	"./fr-ca.json": [
		"./src/assets/i18n/fr-ca.json",
		7
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/assets/i18n lazy recursive ^\\.\\/.*\\.json$";
module.exports = webpackAsyncContext;